import React from "react";

const FooterMobile = () => {
	return (
		<svg width={204} viewBox="0 0 204 352" fill="none">
			<g filter="url(#filter0_f_34_232)">
				<path
					d="M-2.02764 245.489C36.0979 262.461 80.6722 245.107 97.5322 206.73C114.392 168.352 97.1535 123.482 59.0275 106.511C20.9024 89.5389 -23.6722 106.892 -40.5322 145.27C-57.3923 183.648 -40.1532 228.518 -2.02764 245.489Z"
					fill="url(#paint0_radial_34_232)"
					fillOpacity="0.7"
				/>
			</g>
			<defs>
				<filter
					id="filter0_f_34_232"
					x={-147}
					y={0}
					width={351}
					height={352}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="BackgroundImageFix"
						result="shape"
					/>
					<feGaussianBlur
						stdDeviation={50}
						result="effect1_foregroundBlur_34_232"
					/>
				</filter>
				<radialGradient
					id="paint0_radial_34_232"
					cx={0}
					cy={0}
					r={1}
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(174.958 269.014) rotate(-154.291) scale(349.263 318.468)"
				>
					<stop offset="0.281116" stopColor="#00EBFF" />
					<stop offset="0.67478" stopColor="#FF39B0" />
					<stop offset="0.770833" stopColor="#161C1B" />
				</radialGradient>
			</defs>
		</svg>
	);
};

export default FooterMobile;
